export default __webpack_public_path__ + "./assets/product-card-model3__33cfdbdd11cd472c6add0e57eacc6c0b.png";